import 'jquery.easing';
import 'slick-carousel';
import 'jquery-inview';

import { Initialize } from './initialize';
new Initialize;

import './form';

// Webフォントの読み込み遅延対策
setTimeout(function () {
	document.getElementsByTagName("html")[0].classList.add("loading-delay");
}, 3000);

// .fn-parallax パララックス
(function($) {
	const element = '.fn-parallax';
	const $element = $(element);
	const amount = 0.2;
	if (! $element[0]) {
		return;
	}
	console.log($(window).width());
	if ( (! $('html').hasClass('mac') && ! $('html').hasClass('win')) || $(window).width() < 1000) {
		return;
	}
	$element.each(function(i, el){
		let scrollTop = $(el).offset().top; //初期値を取得
		let styleTop = parseFloat($(el).css('top')); //既存のtopの値を取得
		$(window).scroll(function() {
			let value = $(this).scrollTop(); //スクロールの値を取得
			let posiTop = -(scrollTop - value) * amount + styleTop;
			$(element + '__bg', el).css('top', posiTop);
		});
	});
})(jQuery);

// .fn-topHero TOPヒーローのアニメーション
(function($) {
	let el = '.fn-topHero';
	let $el = $(el);
	if (! $el[0]) {
		return;
	}
	$el.on('inview', function(e, isInView){
		if(isInView) {
			$(this).addClass('is-show');
			setTimeout(function(){
				$(el + '__text02').addClass('is-show');
				setTimeout(function(){
					$(el + '__text03').addClass('is-show');
				}, 300);
				setTimeout(function(){
					$(el + '__text01').addClass('is-show');
				}, 700);
				setTimeout(function(){
					$(el + '__text04').addClass('is-show');
				}, 1000);
			}, 0);
		}
	});
})(jQuery);

// .fn-wysiwyg WYSIWYGカスタマイズ
(function($) {
	let element = '.fn-wysiwyg';
	let $element = $(element);
	if (! $element[0]) {
		return;
	}
	// テーブルをレスポンシブ対応に
	$('table', $element)
		.wrap('<div class="c-table-responsive"></div>');
})(jQuery);

// .fn-inview addClassパターンのinview
(function($) {
	let element = '.fn-inview';
	let $element = $(element);
	if (! $element[0]) {
		return;
	}
	$element.on('inview', function(e, isInView) {
		if(isInView) {
			$(this).addClass('is-inview');
		}
	});
})(jQuery);

// タブ
(function($) {
	$.fn.tab = function(options) {

		// オプションをセット
		var settings = $.extend({
			buttonClass: ".tab_navButton",
			contentClass: ".tab_content",
			currentClassName: "is-current"
		}, options);

		var buttonClass = settings.buttonClass;
		var contentClass = settings.contentClass;
		var currentClassName = settings.currentClassName;

		return this.each(function() {
			var nav = this;
			var $nav = $(nav);

			// はじめにすべてのコンテンツを隠す
			$(contentClass, nav).hide();

			// クリックしたらタブを表示(他のタブは非表示)
			$(buttonClass, nav).on('click', function(){
				var index = $(buttonClass, nav).index(this);
				$(buttonClass, nav)
					.removeClass(currentClassName)
					.eq(index).addClass(currentClassName);
				$(contentClass, nav)
					.hide()
					.eq(index).show();
			});

			// はじめのタブを擬似的にクリックさせる
			$(buttonClass, nav).eq(0).trigger('click');
		});
	}
})(jQuery);

(function($) {
	let element = '.fn-tab';
	let $element = $(element);
	if (! $element[0]) {
		return;
	}
	$element.tab({
		buttonClass: element + '__tab',
		contentClass: element + '__content',
		currentClassName: 'is-current'
	});
})(jQuery);

// .fn-yearLabel マンスリーマーケットの年ラベル
(function($) {
	let element = '.fn-yearLabel';
	let $element = $(element);
	if (! $element[0]) {
		return;
	}
	let year = '';
	$('section', $element).each(function(index, el){
		if( year != $(el).data('year') ) {
			$(el).addClass('is-first');
		}
		year = $(el).data('year');
	});
})(jQuery);

// .fn-header
(function($) {
	const element = '.fn-header';
	const $element = $(element);
	if (! $element[0]) {
		return;
	}
	// ヘッダーのSPメニュー展開
	$(element + '__spMenuButton').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('active');
		$(element + '__nav').toggleClass('is-show');
		return false;
	});
	// ナビゲーションのホバー時クラス付与
	let $current = $(element + '__current');
	// カレントをセット
	function setCurrent(element, first = false) {
		let $current = $(element + '__current');
		let current_num = $(element + '__nav').data('current');
		if (current_num >= 1 || current_num === 0) {
			let $is_current = $(element + '__li').eq(current_num);
			let left = $is_current.position().left;
			left = left + ($is_current.width() / 2) - 6;
			if (first) {
				$current.css({
					'display': 'block',
					'left': left
				});
			} else {
				$current.stop().animate({
					left: left
				}, 300, 'easeOutExpo');
			}
			return false;
		} else {
			$current.hide();
		}
	}
	// メニューホバーで
	$(element + '__li').on('mouseover', function(){
		let left = $(this).position().left;
		left = Math.floor(left + ($(this).width() / 2) - 6);
		if ($current.css('display') != 'block') {
			$current.css({
				'display': 'block',
				'left': left
			});
		} else {
			$current.stop().animate({
				left: left
			}, 600, 'easeOutExpo');
		}
	});
	$(element + '__nav').on('mouseleave', function(){
		setCurrent(element);
	});
	$('.l-header__navApply').on('mouseover', function(){
		setCurrent(element);
	});
	// Typekit
	try {
		Typekit.load({
			loading: function() {
				// JavaScript to execute when fonts start loading
			},
			active: function() {
				setCurrent(element, true);
			},
			inactive: function() {
				setCurrent(element, true);
			}
		})
	} catch(e) {}
})(jQuery);

// .p-fvc-voice FVCページ 企業スライダー
let fvcVoiceSlick;
(function($) {
	let element = '.p-fvc-voice';
	let $element = $(element);
	if (! $element[0]) {
		return;
	}
	fvcVoiceSlick = $('.p-fvc-voice__listInner').slick({
		slidesToShow: 1,
		arrows: true,
		adaptiveHeight: true
	});
	$('.p-fvc-voice__listPager li').eq(0).addClass('is-current');
	$('.p-fvc-voice__listPager li').on('click', function(){
		$('.p-fvc-voice__listPager li').removeClass('is-current');
		$(this).addClass('is-current');
		let index = $(this).attr('data-index');
		fvcVoiceSlick.slick('slickGoTo', parseInt(index));
	});
})(jQuery);

// .fn-fvcVoice FVC スライダー内More展開(SPのみ)
(function($) {
	let element = '.fn-fvcVoice';
	let $element = $(element);
	if (! $element[0]) {
		return;
	}
	let slickItem = $('.p-fvc-voice .slick-list');
	$($element).each(function(index, el){
		let $this = $(el);
		$(element + '__more, ' + element + '__close', el).on('click', function(e) {
			e.preventDefault();
			$this.toggleClass('is-opened');
			$('.p-fvc-voice .slick-list').removeAttr('style');
			$(element + '__text', el).slideToggle(300, function(){
				slickItem.height($this.height());
				slickItem.height($this.height()); // Safari対策
			});
		});
	});
})(jQuery);

// a[href^="#"]:not(.no-smooth) スムーズスクロール
(function($) {
	let element = 'a[href^="#"]:not(.no-smooth)';
	let $element = $(element);
	if (! $element[0]) {
		return;
	}
	$element.on('click', function(e){
		e.preventDefault();
		let target = $(this).attr('href');
		let pos = $(target).offset().top - 100;
		$('html, body').animate({scrollTop: pos + 'px'}, 500, 'easeInOutCubic');
	});
})(jQuery);

// .fn-entry ENTRY readmore展開(SPのみ)
(function($) {
	let element = '.fn-entry';
	let $element = $(element);
	if (! $element[0]) {
		return;
	}
	$(element + '__more a').on('click', function(e) {
		e.preventDefault();
		$(element + '__expand').css({'display': 'block'});
		$(element + '__more').hide();
	});
})(jQuery);

// .fn-fvcMore FVC クラブ役員のMore展開(SPのみ)
(function($) {
	let element = '.fn-fvcMore';
	let $element = $(element);
	if (! $element[0]) {
		return;
	}
	$('a', $element).on('click', function(e) {
		e.preventDefault();
		$('.fn-fvcMoreContainer').slideToggle();
		$element.hide();
	});
})(jQuery);

//登壇企業検索 最新の年まで表示
(function($) {
  const nowYear = new Date().getFullYear();
  const nowMonth = new Date().getMonth() + 1;
  const url = new URL(location.href);
  const searchParams = new URLSearchParams(url.search);
  const startYear = $('.js-startYear');
  const startMonth = $('.js-startMonth');
  const endYear = $('.js-endYear');
  const endtMonth = $('.js-endMonth');
  //開始時期
  if (nowMonth === 1) {
    for (let i = 2011; i <= nowYear; i++) {
      const option = $('<option>', {
        value: i - 1,
        text: i - 1
      });
      startYear.append(option);
    }
  } else {
    for (let i = 2010; i <= nowYear; i++) {
      const option = $('<option>', {
        value: i,
        text: i
      });
      startYear.append(option);
    }
  }
  startYear.on('change', function() {
    const selectedYear = parseInt($(this).val());
    startMonth.empty();
    for (let i = 1; i <= 12; i++) {
      if (i <= 9) {
        var option = $('<option>', {
          value: "0" + i,
          text: "0" + i
        });
      } else if (i >= 10) {
        var option = $('<option>', {
          value: i,
          text: i
        });
      }
      if (selectedYear === nowYear && i + 1 <= nowMonth) {
        startMonth.append(option);
      } else if (selectedYear < nowYear) {
        startMonth.append(option);
      } else if (selectedYear === nowYear && nowMonth === 1) {
        startMonth.append(option);
      }
    }
  });
  const sy = searchParams.get('sy');
  const sm = searchParams.get('sm');
  for (let i = 1; i <= 12; i++) {
    if (i <= 9) {
      var option = $('<option>', {
        value: "0" + i,
        text: "0" + i
      });
    } else if (i >= 10) {
      var option = $('<option>', {
        value: i,
        text: i
      });
    }
    if (parseInt(sy) === nowYear && i + 1 <= nowMonth) {
      startMonth.append(option);
    } else if (parseInt(sy) < nowYear) {
      startMonth.append(option);
    }
  }
  const startOption = $('<option>', {
    value: sm,
    text: sm
  });
  startOption.attr('selected', true);

  //終了時期
  if (nowMonth === 1) {
    for (let i = 2011; i <= nowYear; i++) {
      const option = $('<option>', {
        value: i - 1,
        text: i - 1
      });
      endYear.append(option);
    }
  } else {
    for (let i = 2010; i <= nowYear; i++) {
      const option = $('<option>', {
        value: i,
        text: i
      });
      endYear.append(option);
    }
  }
  endYear.on('change', function() {
    const selectedYear = parseInt($(this).val());
    endtMonth.empty();
    for (let i = 1; i <= 12; i++) {
      if (i <= 9) {
        var option = $('<option>', {
          value: "0" + i,
          text: "0" + i
        });
      } else if (i >= 10) {
        var option = $('<option>', {
          value: i,
          text: i
        });
      }
      if (selectedYear === nowYear && i + 1 <= nowMonth) {
        endtMonth.append(option);
      } else if (selectedYear !== nowYear) {
        endtMonth.append(option);
      } else if (selectedYear === nowYear && nowMonth === 1) {
        endtMonth.append(option);
      }
    }
  });
  const ey = searchParams.get('ey');
  const em = searchParams.get('em');
  for (let i = 1; i <= 12; i++) {
    if (i <= 9) {
      var option = $('<option>', {
        value: "0" + i,
        text: "0" + i
      });
    } else if (i >= 10) {
      var option = $('<option>', {
        value: i,
        text: i
      });
    }
    if (parseInt(ey) === nowYear && i + 1 <= nowMonth) {
      endtMonth.append(option);
    } else if (parseInt(ey) !== nowYear) {
      endtMonth.append(option);
    }
  }
  const endOption = $('<option>', {
    value: em,
    text: em
  });
  endOption.attr('selected', true);
})(jQuery);

// .fn-formPartsValue 既に入力・選択されたデータのフォームパーツへの反映
(function($) {
	const element = '.fn-formPartsValue';
	const $element = $(element);
	if (! $element[0]) {
		return;
	}
	$element.each(function(index, el){
		const $this = $(el);
		const val = $this.data('value');
		$this.val(val);
	});
})(jQuery);

// .fn-imageAspectFix 画像の比率を固定する(どんな比率や大きさでも)
(function($){

	// 画像縦横比を固定(asp_w:asp_h)
	$.fn.setImageAspectFix = function(options){

		// options
		var c = $.extend({
			w: 4, // 横の比率
			h: 3, // 縦の比率
			lowSizeFit: true // 枠より小さい場合、拡大するかどうか
		}, options);

		// main
		this.each(function(index, el) {
			$(window).on('load resize', function() {
				var w = $(el).innerWidth();
				var h = w / c.w * c.h;

				var img = new Image();
				img.src = $('img', el).attr('src');
				var img_w = img.width;
				var img_h = img.height;

				if(c.lowSizeFit || w < img_w){
					if (c.h/c.w >= img_h/img_w) {
						var zoom = h / img_h;
					}else{
						var zoom = w / img_w;
					}
				}

				$('img', el).css({
					height: img_h * zoom,
					width: img_w * zoom,
					minWidth: img_w * zoom
				});

				$(el).css({
					'overflow': 'hidden',
					'height': h
				});
			});
		});
	};

	$('.fn-imageAspectFix').setImageAspectFix({w:1, h:1});

})(jQuery);

// .fn-language 日英切り替えでlang属性変更
(function ($) {
  const element = '.fn-language';
  const $element = $(element);
  if (!$element[0]) {
    return;
  }
  setTimeout(function () {
    $element.each(function () {
      if ($(this).attr('data-stt-active') === "") {
        $('html').addClass($(this).attr('data-stt-changelang'));
      }
    });
  }, 5000);
  $element.on('click', function () {
    $('html').removeClass('ja en');
    $('html').addClass($(this).attr('data-stt-changelang'));
  });
})(jQuery);
